import { render, staticRenderFns } from "./filter-comp.vue?vue&type=template&id=024f9172&"
import script from "./filter-comp.vue?vue&type=script&lang=js&"
export * from "./filter-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports